import { BooleanInput } from '@angular/cdk/coercion';
import {
  ChangeDetectionStrategy,
  Component,
  booleanAttribute,
  input,
} from '@angular/core';
import { MatIcon } from '@angular/material/icon';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: '[procure-toolbar-button]',
  templateUrl: './toolbar-button.component.html',
  styleUrl: './toolbar-button.component.scss',
  imports: [MatIcon],
  host: {
    '[class.has-label]': 'label()',
    '[class.active]': 'active()',
    '[class.large]': 'large()',
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ToolbarButton {
  readonly icon = input.required<string>();
  readonly label = input<string>();

  readonly active = input<boolean, BooleanInput>(false, {
    transform: booleanAttribute,
  });

  readonly large = input<boolean, BooleanInput>(false, {
    transform: booleanAttribute,
  });

  readonly isDropdown = input<boolean, BooleanInput>(false, {
    transform: booleanAttribute,
  });

  readonly isLoading = input<boolean, BooleanInput>(false, {
    transform: booleanAttribute,
  });
}
